export default __webpack_public_path__ + "static/media/Benton-Sans-Wide-Bold.f60faf41.otf";